import { render, staticRenderFns } from "./dialogDeletePositionLevelInGroup.vue?vue&type=template&id=2f9c1cba&scoped=true"
import script from "./dialogDeletePositionLevelInGroup.vue?vue&type=script&lang=js"
export * from "./dialogDeletePositionLevelInGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9c1cba",
  null
  
)

export default component.exports